import React from "react";
import { useNavigate } from "react-router-dom"

// import car from "../../../../Assets/car.webp";
import car from "../../../../Assets/aboutBack.png";
// import engine from "../../../../Assets/engine.webp";
import engine from "../../../../Assets/contactBack.png";

import "./Career.scss";





const Career = () => {
  let Navigate = useNavigate()
  return (
    <div className="main_car">
      <div className="left_car">
        <div className="img_car">
          <img src={car} />
        </div>

        <div className="text">
          <p className="studio">Flux</p>
          <p className="location" onClick={() => Navigate("/about")}>About Us</p>
        </div>
      </div>

      <div className="right_car">
        <div className="img_car">
          <img src={engine} />
        </div>
        <div className="text">
          <p className="studio">Flux</p>
          <p className="location" onClick={() => Navigate("/contact")}>Contact Us</p>
        </div>
      </div>
    </div>
  );
};

export default Career;
